import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listStatements, formatPeriodLabel, formatUsd } from '../lib/statements';
import SectionBanner from '../components/SectionBanner';

function currentPeriod() {
  const d = new Date();
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

function last12Periods() {
  const out = [];
  const d = new Date();
  d.setUTCDate(1);
  for (let i = 0; i < 12; i++) {
    out.push(`${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`);
    d.setUTCMonth(d.getUTCMonth() - 1);
  }
  return out;
}

export default function Statements() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    listStatements()
      .then((data) => alive && setItems(data || []))
      .catch(() => alive && setItems([]))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  // Merge generated statements with the empty placeholders for past 12 months
  const byPeriod = new Map(items.map((s) => [s.period, s]));
  const rows = last12Periods().map((p) => ({ period: p, doc: byPeriod.get(p) || null }));

  return (
    <div className="px-4 sm:px-10 py-6 max-w-3xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#181D27] mb-1">Tus extractos</h1>
        <p className="text-sm text-[#6B7280]">
          Resumen mensual de tu actividad en FlowexPay. Los extractos se generan automáticamente el 1 de cada mes.
        </p>
      </div>

      <SectionBanner
        id="statements"
        title="Tu resumen de cada mes"
        text="Cuánto tienes, cuánto se movió y cuánto rindió. Lo descargas en PDF y lo escuchas con la voz del Oráculo."
      />

      {loading ? (
        <div className="text-sm text-[#6B7280]">Cargando...</div>
      ) : (
        <div className="bg-white border border-[#EFF1F4] rounded-xl divide-y divide-[#EFF1F4]">
          {rows.map(({ period, doc }) => {
            const isCurrent = period === currentPeriod();
            return (
              <div key={period} className="px-5 py-4 flex items-center justify-between">
                <div>
                  <div className="text-sm font-medium text-[#181D27]">{formatPeriodLabel(period)}</div>
                  {doc ? (
                    <div className="text-xs text-[#6B7280] mt-0.5">
                      Saldo cierre {formatUsd(doc.closingBalanceUsd)}
                      {doc.summary?.totalInvestedUsd ? ` · Invertido ${formatUsd(doc.summary.totalInvestedUsd)}` : ''}
                      {doc.summary?.totalCrossBorderUsd ? ` · Enviado ${formatUsd(doc.summary.totalCrossBorderUsd)}` : ''}
                    </div>
                  ) : (
                    <div className="text-xs text-[#6B7280] mt-0.5">
                      {isCurrent ? 'Se generara el 1 del proximo mes' : 'Sin actividad registrada'}
                    </div>
                  )}
                </div>
                {doc || !isCurrent ? (
                  <Link
                    to={period} // relativo: sirve en /dashboard/statements y /business/extractos
                    className="text-xs px-3 py-1.5 rounded-md border border-[#EFF1F4] hover:bg-[#F9FAFB] text-[#0A2540]"
                  >
                    Ver
                  </Link>
                ) : (
                  <span className="text-xs text-[#9CA3AF]">Pendiente</span>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
